// @ts-ignore
import $ from 'jquery'
// @ts-ignore
import { Deferred } from 'simply-deferred';


// const debug = "AjaxRequestSharedView";
const debug = false;

export default function AjaxRequest(obj:any, processSessionResponse=true, autoError=true) {

    debug && console.log(debug, "new AjaxRequest", obj)

    let result = Deferred();

    let settings : DictionaryStringAny = {
        url             : gdConfig.apiSharedView + obj.endpoint,
        'xhrFields'     : {  // enable browser to send cookie
            withCredentials: true
        }
    };

    switch (obj['type'].toUpperCase()) {
        case 'GET':
            settings['type'] = 'GET';
            settings['data'] = obj.data;
            // settings['contentType'] = 'application/json';
            // settings['dataType'] = 'json';
            break;
        case 'POST':
            settings['type'] = 'POST';
            settings['data'] = JSON.stringify(obj.data);
            settings['contentType'] = 'application/json';
            settings['dataType'] = 'json';
            break;
        case 'PUT':
            settings['type'] = 'PUT';
            settings['data'] = JSON.stringify(obj.data);
            settings['contentType'] = 'application/json';
            settings['dataType'] = 'json';
            break;
        case 'DELETE':
            settings['type'] = 'DELETE';
            settings['data'] = obj.data;
            // settings['contentType'] = 'application/json';
            // settings['dataType'] = 'json';
            break;
        case 'UPLOAD':
            settings['type'] = 'POST';
            settings['data'] = obj.data;
            settings['processData'] = false;
            settings['contentType'] = false;
            break;
    }



    let ajax = $.ajax(settings).done((response:any) => {

        debug && console.log(debug, "done()  response=",response);

        // try {
        if (response) {
            // Process session
            if (response.session && processSessionResponse) {
                gd.session.processEvents(response.session);
            }

            // Process old session
            if (response.data && response.data.session) {
                gd.session.processEvents(response.data.session);
            }
        }
        // } catch (e) {}

        debug && console.log("resolve result=",result,"context=",obj.context,"data=",response);

        result.resolveWith(obj.context,[response])

    }).fail(function (jqXHR:any, exception:any) {

        // ignore aborts...
        if (ajax.statusText == 'abort') return;

        let errorMessage = (jqXHR.responseJSON && jqXHR.responseJSON.errorMessage)?jqXHR.responseJSON.errorMessage:false;

        const errorsObj = {
            code: parseInt(jqXHR.status),
            errorMessage: errorMessage
        };

        gd.apiError(errorsObj);

        result.rejectWith(obj.context,[errorsObj]);
    });

    //Abort ... which calls fail... not sure if needed
    //result.progress(function (what) {
    //    if (what == 'abort') ajax.abort();
    //});

    result.abort = function() {
        ajax.abort();
    };

    return result

};